import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '../mui/Core/index'
import SelectClientDropdown from '../dropdowns/SelectClientDropdown/select-client-dropdown'
import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'

function ClientSelection({ message, handleSelectOption }) {
  const currentState = sessionStorage.getItem(sessionStorageKeyConstants.SELECTED_CLIENT)

  const rootStyle = { flexGrow: 1 }
  const messageContainerStyle = {
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    top: '50%',
    left: '50%',
    height: '50%',
    width: '50%',
  }

  return (
    <Box sx={rootStyle}>
      <SelectClientDropdown currentState={currentState} handleSelectOption={handleSelectOption} />
      <Box sx={messageContainerStyle}>
        <Typography variant='cardMessage'>{message}</Typography>
      </Box>
    </Box>
  )
}

ClientSelection.propTypes = {
  message: PropTypes.string,
  handleSelectOption: PropTypes.func,
}

export default ClientSelection
